import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import { LangdingPageNavBarComponent } from '../../langding-page-nav-bar/langding-page-nav-bar.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-price-table',
  standalone: true,
  imports: [CommonModule, LangdingPageNavBarComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './price-table.component.html',
  styleUrls: ['./price-table.component.scss']
})
export class PriceTableComponent implements OnInit {
  summarylist: any;
  constructor(private api: ApiService, private util: UtilService) { }

  ngOnInit() {
    this.pricesummary();
  }
  pricesummary() {
    const userId = localStorage.getItem("userId");
    this.api
      .query("user/findUserPlanBenefits/" + userId)
      .subscribe((res) => {

        this.summarylist = res.data.userPlanAndBenefits.benefitsUsages;
        console.log(res)
      }, err => {
        this.util.stopLoader();
      });
  }
}
